export const globalPermissionsForUserSelector = (state) =>
  (state.account && state.account.globalPermissionsForUser) || {};
